export default function VariantPicker({ product, value, onChange, size = "sm", testid = "variant" }) {
  const groups = [["option", "Choose", (product.options || []).map((o) => o.label)], ["size", "Size", product.sizes || []], ["color", "Color", product.colors || []]].filter(([, , opts]) => opts.length);
  if (!groups.length) return null;
  const optPrice = (label) => { const o = (product.options || []).find((x) => x.label === label); return o ? `$${Number(o.price).toFixed(2).replace(/\.00$/, "")}` : ""; };
  const pad = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2 py-1 text-[10px]";
  const thumb = size === "lg" ? "w-5 h-5" : "w-4 h-4";
  const photos = product.color_photos || {};
  return (
    <div className="space-y-2" data-testid={testid} onClick={(e) => e.stopPropagation()}>
      {groups.map(([key, label, opts]) => (
        <div key={key}>
          <div className="text-[9px] uppercase tracking-[0.2em] text-zinc-500 mb-1">{label}{value?.[key] ? <span className="text-white ml-1.5 normal-case tracking-normal font-semibold">{value[key]}</span> : <span className="text-pb-red ml-1.5">· choose</span>}</div>
          <div className="flex flex-wrap gap-1">
            {opts.map((o) => (
              <button key={o} type="button" data-testid={`${testid}-${key}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                onClick={() => onChange({ ...(value || {}), [key]: o })}
                className={`inline-flex items-center gap-1.5 border font-bold uppercase tracking-wider transition-colors ${pad} ${value?.[key] === o ? "bg-pb-red text-black border-pb-red" : "border-pb-border text-zinc-300 hover:border-pb-red hover:text-white"}`}>
                {key === "color" && photos[o] && <img src={photos[o]} alt="" className={`${thumb} object-cover border border-black/30`} data-testid={`${testid}-swatch-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />}
                {o}{key === "option" && <span className={`font-mono normal-case tracking-normal ${value?.[key] === o ? "text-black/70" : "text-pb-red"}`}>{optPrice(o)}</span>}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export const variantComplete = (product, v) =>
  (!(product.options || []).length || !!v?.option) && (!(product.sizes || []).length || !!v?.size) && (!(product.colors || []).length || !!v?.color);

export const variantLabel = (v) => [v?.option, v?.size, v?.color].filter(Boolean).join(" · ");

export const variantPrice = (product, v) => {
  const o = v?.option && (product.options || []).find((x) => x.label === v.option);
  return o ? Number(o.price) : Number(product.price);
};

export const productImages = (p) => (p.images?.length ? p.images : [p.image].filter(Boolean));

export const colorPhotoIndex = (p, v) => {
  const src = v?.color && p.color_photos?.[v.color];
  if (!src) return null;
  const i = productImages(p).indexOf(src);
  return i >= 0 ? i : null;
};
